<script setup lang="ts">
definePageMeta({
  layout: false,
})

if (import.meta.client) {
  await useOidcClient().authorize()

  const redirect = useRedirectCookie()

  await navigateTo(redirect.value || { name: "hjem" })
}
</script>

<template>
  <UArticleLoadingScreen />
</template>
